import { Controller } from "@hotwired/stimulus";
import * as echarts from "echarts";
import * as Turbo from "@hotwired/turbo";

export default class extends Controller {
  static targets = ["chartBody"];
  static values = {
    urlTemplate: String,
  };

  connect() {
    this.chart = null;
    this.chartData = null;
    this.initializeChart();
  }

  initializeChart() {
    if (!this.hasChartBodyTarget) {
      return;
    }

    if (echarts.getInstanceByDom(this.chartBodyTarget)) {
      this.chart = echarts.getInstanceByDom(this.chartBodyTarget);
      return;
    } else {
      this.isInitialized = false;
    }

    this.chart = echarts.init(this.chartBodyTarget);
    this.chart.setOption({
      tooltip: {
        trigger: "axis",
      },
      xAxis: {
        type: "value",
      },
      yAxis: {
        type: "category",
        inverse: true,
      },
      series: [
        {
          name: "Notices",
          type: "bar",
          realtimeSort: true,
          color: ["#DB6243"],
        },
      ],
      grid: {
        containLabel: true,
        left: "0",
        right: "15",
        top: "0",
        bottom: "0",
      },
    });

    // When a user clicks on a single notice bar.
    this.chart.on("click", (params) => {
      if (params.seriesName != "Notices") {
        return;
      }

      const metadata = this.chartData[params.dataIndex][2];
      const destination = this.interpolate(this.urlTemplateValue, { metadata });

      Turbo.visit(destination);
    });
  }

  interpolate(s, obj) {
    return s.replace(/[$]{([^}]+)}/g, function (_, path) {
      const properties = path.split(".");
      return properties.reduce((prev, curr) => prev && prev[curr], obj);
    });
  }

  updateData(e) {
    this.chartData = e.detail.data;
    this.redrawChart();
  }

  redrawChart() {
    if (!this.chart) {
      return;
    }

    this.chart.setOption({
      yAxis: {
        data: this.chartData.map((data) => data[1]),
      },
      series: [
        {
          name: "Notices",
          data: this.chartData,
        },
      ],
    });

    if (this.isInitialized) {
      this.chart.resize();
    } else {
      this.isInitialized = true;
    }
  }

  resizeChart() {
    if (!this.chart) {
      return;
    }

    this.chart.resize();
  }
}
